/* Winter 2027 - free-shipping progress bar for the cart drawer and cart page */
(function () {
  if (window.__w27cart) return;
  window.__w27cart = true;

  var total = null;
  var fetching = false;
  var again = false;
  var observer = null;

  function cfg() {
    var el = document.querySelector('[data-w27-ship]');
    if (!el) return null;
    return {
      threshold: parseInt(el.getAttribute('data-threshold'), 10),
      currency: el.getAttribute('data-currency') || '',
      more: el.getAttribute('data-msg-more') || 'Add {amount} more for free shipping',
      done: el.getAttribute('data-msg-done') || 'You have unlocked free shipping'
    };
  }

  function fetchTotal() {
    if (fetching) { again = true; return; }
    fetching = true;
    fetch('/cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (c) { total = c.total_price; render(); })
      .catch(function () {})
      .then(function () {
        fetching = false;
        if (again) { again = false; fetchTotal(); }
      });
  }

  function mountPoints() {
    var out = [];
    var drawerHeader = document.querySelector('cart-drawer:not(.is-empty) .drawer__header');
    if (drawerHeader) out.push({ anchor: drawerHeader, kind: 'drawer' });
    var pageTitle = document.querySelector('cart-items:not(.is-empty) .title-wrapper-with-link');
    if (pageTitle) out.push({ anchor: pageTitle, kind: 'page' });
    return out;
  }

  function render() {
    var c = cfg();
    if (!c || !c.threshold || total === null) return;
    var reached = total >= c.threshold;
    var remaining = Math.ceil((c.threshold - total) / 100);
    var text = reached
      ? c.done
      : c.more.replace('{amount}', remaining + ' ' + c.currency);
    var pct = Math.min(100, Math.round((total / c.threshold) * 100)) + '%';

    mountPoints().forEach(function (m) {
      var next = m.anchor.nextElementSibling;
      var bar = next && next.hasAttribute('data-w27-bar') ? next : null;
      if (!bar) {
        bar = document.createElement('div');
        bar.setAttribute('data-w27-bar', '');
        bar.className = 'w27-ship w27-ship--' + m.kind;
        bar.innerHTML = '<p class="w27-ship__msg"></p><div class="w27-ship__track"><span class="w27-ship__fill"></span></div>';
        m.anchor.insertAdjacentElement('afterend', bar);
      }
      var msg = bar.querySelector('.w27-ship__msg');
      var fill = bar.querySelector('.w27-ship__fill');
      if (msg.textContent !== text) msg.textContent = text;
      if (fill.style.width !== pct) fill.style.width = pct;
      bar.classList.toggle('is-done', reached);
    });

    /* our own DOM changes must not trigger another refresh */
    if (observer) observer.takeRecords();
  }

  function refresh() {
    if (mountPoints().length) fetchTotal();
  }

  var timer;
  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(refresh, 400);
  }

  function start() {
    refresh();
    if ('MutationObserver' in window) {
      observer = new MutationObserver(schedule);
      observer.observe(document.body, { childList: true, subtree: true });
    }
    if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, schedule);
    }
  }

  if (document.readyState !== 'loading') start();
  else document.addEventListener('DOMContentLoaded', start);
})();
